import { render, staticRenderFns } from "./direction-data.vue?vue&type=template&id=520ad5d1&scoped=true"
import script from "./direction-data.vue?vue&type=script&lang=js"
export * from "./direction-data.vue?vue&type=script&lang=js"
import style0 from "./direction-data.vue?vue&type=style&index=0&id=520ad5d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ad5d1",
  null
  
)

export default component.exports